import { useState, useEffect } from 'react';
import { Card, Button, Modal, Form, Row, Col, InputGroup } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';

import Layout from '../../layout/default';
import Block from '../../components/Block/Block';
import DataTable from '../../components/DataTable/DataTable';
import { Icon } from '../../components';
import { userColumns } from '../../store/coupons/CouponsData';
import "../../assets/CouponsList.css";
import 'react-toastify/dist/ReactToastify.css';
import instance from "../api";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Swal from "sweetalert2";

function CouponsList() {
  const { coupon_id } = useParams();

   // NEW CODE
  const [ searchText, setSearchText ] = useState("")
  // NEW CODE ENDS



  const [showModal, setShowModal] = useState(false);
  const [couponsData, setCouponsData] = useState([]);
  const [couponCode, setCouponCode] = useState('');
  const [indMinAmount, setIndMinAmount] = useState(null);
  const [outsideIndMinAmount, setOutsideIndMinAmount] = useState(null);
  const [discountType, setDiscountType] = useState('');
  const [indiaValue, setIndiaValue] = useState('');
  const [outsideIndValue, setOutsideIndValue] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [editingCoupon, setEditingCoupon] = useState(null);
  const [minAmountRequired, setMinAmountRequired] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();
  const [fieldErrors, setFieldErrors] = useState({
    couponCode: false,
    discountType: false,
    indiaValue: false,
    outsideIndValue: false,
    startDate: false,
    endDate: false,
    indMinAmount: false,
    outsideIndMinAmount: false,
  });

  const handleCloseModal = () => {
    setShowModal(false);
    navigate('/coupons-manage/coupons-list');
    setCouponCode('');
    setDiscountType('');
    setIndiaValue('');
    setOutsideIndValue('');
    setIndMinAmount(null);
    setOutsideIndMinAmount(null);
    setStartDate('');
    setEndDate('');
    setMinAmountRequired(false);
    setEditingCoupon(null);
    setFieldErrors({
      couponCode: false,
      discountType: false,
      indiaValue: false,
      outsideIndValue: false,
      startDate: false,
      endDate: false,
      indMinAmount: false,
      outsideIndMinAmount: false,
    });
  };

  const handleShowModal = () => setShowModal(true);

  const validateForm = () => {
    const errors = {};

    if (!couponCode) {
      errors.couponCode = true;
    }

    if (minAmountRequired) {
      // if (!indMinAmount) {
      //   errors.indMinAmount = true;
      // }
      if (!outsideIndMinAmount) {
        errors.outsideIndMinAmount = true;
      }
    }

    if (!discountType) {
      errors.discountType = true;
    }

    // if (!indiaValue) {
    //   errors.indiaValue = true;
    // } else {
    //   const indiaValueNum = parseFloat(indiaValue);
    //   if (isNaN(indiaValueNum)) {
    //     errors.indiaValue = true;
    //     Swal.fire("Error", "India Value must be a number.", "error");
    //   } else {
    //     if (discountType === '2') { // Percentage
    //       if (indiaValueNum <= 0 || indiaValueNum > 100) {
    //         errors.indiaValue = true;
    //         Swal.fire("Error", "India Discount value must be between 0 and 100%.", "error");
    //       }
    //     } else if (discountType === '1') { // Fixed
    //       if (indiaValueNum <= 0) {
    //         errors.indiaValue = true;
    //         Swal.fire("Error", "India Discount value must be greater than 0.", "error");
    //       }
    //     }
    //   }
    // }
  
    // Validate Outside India Value
    if (!outsideIndValue) {
      errors.outsideIndValue = true;
    } else {
      const outsideIndValueNum = parseFloat(outsideIndValue);
      if (isNaN(outsideIndValueNum)) {
        errors.outsideIndValue = true;
        Swal.fire("Error", "International Value must be a number.", "error");
      } else {
        if (discountType === '2') { // Percentage
          if (outsideIndValueNum <= 0 || outsideIndValueNum > 100) {
            errors.outsideIndValue = true;
            Swal.fire("Error", "International Discount value must be between 0 and 100%.", "error");
          }
        } else if (discountType === '1') { // Fixed
          if (outsideIndValueNum <= 0) {
            errors.outsideIndValue = true;
            Swal.fire("Error", "International Discount value must be greater than 0.", "error");
          }
        }
      }
    }
  
  

    if (!startDate) {
      errors.startDate = true;
    }

    if (!endDate) {
      errors.endDate = true;
    }

    // console.log("Validation errors:", errors); // Log any errors found

    setFieldErrors(errors);

    if (Object.values(errors).some((error) => error)) {
      return false;
    }

    return true;
  };

  const fetchCouponDetails = async () => {
    try {
      const response = await instance.get(`api/Coupon/${coupon_id}`);
      const coupon = response.data;

      setCouponCode(coupon.couponcode || '');
      setDiscountType(coupon.discount_type === "Fixed" ? "1" : "2");
      setIndiaValue(coupon.india_value || '');
      setIndMinAmount(coupon.ind_min_amount || null);
      setMinAmountRequired(!!coupon.ind_min_amount);
      setOutsideIndMinAmount(coupon.outside_ind_min_amount || null);
      setOutsideIndValue(coupon.outside_ind_value || '');
      setStartDate(new Date(coupon.start_date).toISOString().split('T')[0] || '');
      setEndDate(new Date(coupon.end_date).toISOString().split('T')[0] || '');

      setEditingCoupon(coupon);

      handleShowModal();
    } catch (error) {
      console.error('Error fetching coupon details:', error);
    }
  };

  const postCouponData = async () => {
        // console.log("postCouponData called"); // Add this line

    if (!validateForm()) {
      return;
    }
    try {
      const payload = {
        start_date: startDate,
        end_date: endDate,
        discount_type: discountType === "1" ? "Fixed" : "Percentage",
        india_value: 0,
        outside_ind_value: outsideIndValue,
        couponcode: couponCode,
        min_amount_required: minAmountRequired,
        ind_min_amount: minAmountRequired ? indMinAmount : null,
        outside_ind_min_amount: minAmountRequired ? outsideIndMinAmount : null,
      };
      // console.log(payload)
      let response;

      if (editingCoupon) {
        response = await instance.put(`api/Coupon/update/${editingCoupon.coupon_id}`, payload);
      } else {
        response = await instance.post('api/Coupon/Create', payload);
      }
      // console.log("Coupon created successfully:", response.data);

      const updatedResponse = await instance.get('api/Coupon');
      setCouponsData(updatedResponse.data.rows);

      handleCloseModal();
      Swal.fire("Success", "Coupon updated successfully!", "success");
    } catch (error) {
      console.error("Error creating coupon:", error);
      Swal.fire("Error", "Error creating coupon!", "error");
    }
  };

    const fetchData =  async (page, pageSize) => {
      try {
        const queryParams = `pageSize=${pageSize}&page=${page}` + 
          (searchText ? `&search=${searchText}` : '');
        
        const response = await instance.get(
          // `api/Coupon?pageSize=${pageSize}&page=${page}`
          `api/Coupon?${queryParams}`
        );
        setCouponsData(response.data.rows);
        setTotalCount(response.data.count);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    useEffect(() => {
      fetchData(page, rowsPerPage);
      if (coupon_id) {
      fetchCouponDetails();
    }
    }, [ coupon_id, page, rowsPerPage, searchText]);
  
   // NEW CODE
    const handleSearchTextChange = (text) => {
    setSearchText(text);
    };
  // NEW CODE ENDS


  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setRowsPerPage(newSize);
    setPage(0);
};

  const couponColumns = userColumns({ setCouponsData });

  return (
    <Layout title="Coupons List" content="container">
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Coupons List</Block.Title>
            {/* <nav>
              <ol className="breadcrumb breadcrumb-arrow mb-0">
                <li className="breadcrumb-item"><Link to="/home-ecommerce">Home</Link></li>
                <li className="breadcrumb-item"><Link to="">Coupons Manage</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Coupons</li>
              </ol>
            </nav> */}
          </Block.HeadContent>
          <Block.HeadContent>
            <ul className="d-flex">
              <li>
                <Button className="d-md-none" size="md" variant="primary" onClick={handleShowModal}>
                  <Icon name="plus" />
                  <span>Add</span>
                </Button>
              </li>
              <li>
                <Button className="d-none d-md-inline-flex" variant="primary" onClick={handleShowModal}>
                  <Icon name="plus" />
                  <span>Add Coupon</span>
                </Button>
              </li>
            </ul>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block>
        <Card>
          <DataTable
            tableClassName="data-table-head-light table-responsive"
            
            data={couponsData}
            setCouponsData={setCouponsData}
            searchList={[ 'couponcode' ]}
            searchTerm='Coupon Code'
            columns={couponColumns}
             totalCount={totalCount}
             page={page}
             rowsPerPage={rowsPerPage}
             onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage} 
             // NEW ONE 
            onSearchTextChange={handleSearchTextChange}
            // NEW ONE ENDS
             />
        </Card>
      </Block>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{editingCoupon ? 'Edit Coupon' : 'Add Coupon'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form action="#">
            <Row className="g-3">
              <Col lg="6">
                <Form.Group className="form-group">
                  <Form.Label htmlFor="couponcode">Coupon code</Form.Label>
                  <div className="form-control-wrap">
                    <Form.Control
                      id="couponcode"
                      type="text"
                      placeholder="Code"
                      value={couponCode}
                      onChange={(e) => setCouponCode(e.target.value)}
                      required
                      className={fieldErrors.couponCode ? 'is-invalid' : ''}
                    />
                  </div>
                </Form.Group>
              </Col>

              <Col lg="6">
                <Form.Group className="form-group">
                  <Form.Label>Minimum Amount Required</Form.Label>
                  <div className="form-control-wrap">
                    <Form.Check
                      type="checkbox"
                      checked={minAmountRequired}
                      onChange={(e) => setMinAmountRequired(e.target.checked)}
                      label="Yes"
                    />
                  </div>
                </Form.Group>
              </Col>

              {minAmountRequired && (
                <>
                  {/* <Col lg="6">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="indMinAmount">India Minimum Amount</Form.Label>
                      <div className="form-control-wrap">
                        <InputGroup>
                          <InputGroup.Text>₹</InputGroup.Text>
                          <Form.Control
                            id="indMinAmount"
                            type="number"
                            placeholder="India Minimum Amount"
                            value={indMinAmount}
                            onChange={(e) => setIndMinAmount(e.target.value)}
                            required
                            className={fieldErrors.indMinAmount ? 'is-invalid' : ''}
                          />
                        </InputGroup>
                      </div>
                    </Form.Group>
                  </Col> */}
                  <Col lg="6">
                    <Form.Group className="form-group">
                      <Form.Label htmlFor="outsideIndMinAmount">Minimum Amount</Form.Label>
                      <div className="form-control-wrap">
                        <InputGroup>
                          {/* <InputGroup.Text>$</InputGroup.Text> */}
                          <InputGroup.Text>₹</InputGroup.Text>
                          <Form.Control
                            id="outsideIndMinAmount"
                            type="number"
                            placeholder="Minimum Amount"
                            value={outsideIndMinAmount}
                            onChange={(e) => setOutsideIndMinAmount(e.target.value)}
                            required
                            className={fieldErrors.outsideIndMinAmount ? 'is-invalid' : ''}
                          />
                        </InputGroup>
                      </div>
                    </Form.Group>
                  </Col>
                </>
              )}

              <Col lg="6">
                <Form.Group className="form-group">
                  <Form.Label>Discount Type</Form.Label>
                  <div className="form-control-wrap">
                    <Form.Control
                      as="select"
                      value={discountType}
                      required
                      className={fieldErrors.discountType ? 'is-invalid' : ''}
                      onChange={(e) => {
                        setDiscountType(e.target.value);
                      }}
                    >
                      <option value="">Select a type</option>
                      <option value="1">Fixed</option>
                      <option value="2">Percentage</option>
                    </Form.Control>
                  </div>
                  {fieldErrors.discountType && (
                    <div className="invalid-feedback">Please select a type.</div>
                  )}
                </Form.Group>
              </Col>

              {/* <Col lg="6">
                <Form.Group className="form-group">
                  <Form.Label htmlFor="indiaValue">India Value</Form.Label>
                  <div className="form-control-wrap">
                    <InputGroup>
                      {discountType === '1' && <InputGroup.Text>₹</InputGroup.Text>}
                      {discountType === '2' && <InputGroup.Text>%</InputGroup.Text>}
                      <Form.Control
                        id="indiaValue"
                        type="number"
                        placeholder="India Value"
                        value={indiaValue}
                        required
                        onChange={(e) => setIndiaValue(e.target.value)}
                        className={fieldErrors.indiaValue ? 'is-invalid' : ''}
                      />
                    </InputGroup>
                  </div>
                  {fieldErrors.indiaValue && (
                    <div className="invalid-feedback">Please enter a valid India value.</div>
                  )}
                </Form.Group>
              </Col> */}

              <Col lg="6">
                <Form.Group className="form-group">
                  <Form.Label htmlFor="outsideIndValue">Value</Form.Label>
                  <div className="form-control-wrap">
                    <InputGroup>
                      {discountType === '1' && <InputGroup.Text>₹</InputGroup.Text>}
                      {discountType === '2' && <InputGroup.Text>%</InputGroup.Text>}
                      <Form.Control
                        id="outsideIndValue"
                        type="number"
                        placeholder="Value"
                        value={outsideIndValue}
                        required
                        onChange={(e) => setOutsideIndValue(e.target.value)}
                        className={fieldErrors.outsideIndValue ? 'is-invalid' : ''}
                      />
                    </InputGroup>
                  </div>
                  {fieldErrors.outsideIndValue && (
                    <div className="invalid-feedback">Please enter a valid value.</div>
                  )}
                </Form.Group>
              </Col>

              <Col lg="6">
                <Form.Group className="form-group">
                  <Form.Label htmlFor="startDate">Start Date</Form.Label>
                  <div className="form-control-wrap">
                    <DatePicker
                      id="startDate"
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      dateFormat="yyyy-MM-dd"
                      placeholderText="yyyy-mm-dd"
                      className={`form-control ${fieldErrors.startDate ? 'is-invalid' : ''}`}
                      required
                    />
                  </div>
                  {fieldErrors.startDate && (
                    <div className="invalid-feedback">Please enter a valid start date.</div>
                  )}
                </Form.Group>
              </Col>

              <Col lg="6">
                <Form.Group className="form-group">
                  <Form.Label htmlFor="endDate">End Date</Form.Label>
                  <div className="form-control-wrap">
                    <DatePicker
                      id="endDate"
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      dateFormat="yyyy-MM-dd"
                      placeholderText="yyyy-mm-dd"
                      className={`form-control ${fieldErrors.endDate ? 'is-invalid' : ''}`}
                      required
                    />
                  </div>
                  {fieldErrors.endDate && (
                    <div className="invalid-feedback">Please enter a valid end date.</div>
                  )}
                </Form.Group>
              </Col>

              <Col lg="12">
                <div className="d-flex gap g-2">
                  <div className="gap-col">
                    <Button variant="primary" onClick={postCouponData}>
                      {editingCoupon ? 'Update Coupon' : 'Add Coupon'}
                    </Button>
                  </div>
                  <div className="gap-col">
                    <button type="button" className="border-0 btn" onClick={handleCloseModal}>Cancel</button>
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </Layout>
  );
}

export const handleDeleteCoupon = async (couponId, setCouponsData) => {
  const confirmed = window.confirm('Are you sure you want to delete this coupon?');
  if (confirmed) {
    try {
      await instance.delete(`api/Coupon/delete/${couponId}`);
      const updatedResponse = await instance.get('api/Coupon');
      setCouponsData(updatedResponse.data.rows);
    } catch (error) {
      console.error(`Error deleting coupon with ID ${couponId}:`, error);
    }
  }
};

export const handleToggleStatus = async (couponId, isActive, setCouponsData) => {
  const confirmed = window.confirm(`Are you sure you want to ${isActive ? 'mark as Inactive' : 'mark as Active'} this coupon?`);
  if (confirmed) {
    try {
      const payload = { is_active: !isActive };
      await instance.put(`api/Coupon/update/${couponId}`, payload);
      const updatedResponse = await instance.get('api/Coupon');
      setCouponsData(updatedResponse.data.rows);
    } catch (error) {
      console.error(`Error updating status for coupon with ID ${couponId}:`, error);
    }
  }
};

export default CouponsList;
